import RecruiterJobHub from "./RecruiterJobHub";

export { RecruiterJobHub as default };
